import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import ButtonAction from '../ButtonAction';
import ModalContainer from '../ModalContainer';
import ModalHeader from '../ModalHeader';
import ModalButtonsContainer from '../ModalButtonsContainer';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../styles/styles';

const PopupDeleteFile = ({fileName, onDelete}) => {
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const intl = useIntl();
  const header = intl.formatMessage({
    id: 'tab-order-documents-popup-delete-file-header',
    defaultMessage: `Delete file ${fileName}?`
  }, {fileName});

  return (
    <>
      <ButtonAction
        variant={'icon'}
        iconButtonType={'error'}
        label={
          <img
            src={'../../../media/common/Delete_red.svg'}
            alt="delete" className="w-20px h-20px"
          />
        }
        onClick={handleShowModal}
      />
      <ModalContainer show={show} onHide={handleCloseModal} size={'md'}>
        <ModalHeader header={header}/>
        <ModalButtonsContainer customClassnames={largeButtonsPadding}>
          <ButtonAction
            variant={'cancel'}
            onClick={handleCloseModal}
            label={intl.formatMessage({id: 'button-decline', defaultMessage: 'Decline'})}
            customClassnames={buttonCancel}
          />
          <ButtonAction
            onClick={async () => {
              await onDelete();
              setTimeout(() => handleCloseModal(), 1500);
            }}
            useIcon={'/media/common/Check-in-circle_white.svg'}
            label={intl.formatMessage({id: 'button-delete', defaultMessage: 'Delete'})}
            customClassnames={buttonSubmit}
          />
        </ModalButtonsContainer>
      </ModalContainer>
    </>
  );
};

export default PopupDeleteFile;
